// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Util_Array from "../../../../util/Util_Array.bs.js";
import * as Atom_Column from "../../../atom/Atom_Column.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Presse_Page from "../../../../presse/Presse_Page.bs.js";
import * as Atom_Divider from "../../../atom/Atom_Divider.bs.js";
import * as Molecule_Select_Days_Presse from "../../../molecule/Molecule_Select_Days_Presse.bs.js";
import * as Molecule_Select_Week_Presse from "../../../molecule/Molecule_Select_Week_Presse.bs.js";

function reducer(selectedDate, state, action) {
  switch (action.TAG | 0) {
    case /* OnChangeWeek */0 :
        var weekNumber = action._0;
        var nextWeek = Belt_Option.getWithDefault(Util_Array.NonEmpty.find(state.weekRange, (function (item) {
                    return item.weekNumber === weekNumber;
                  })), state.currentWeek);
        var dayRange = Presse_Page.Guide.updateStatusIntoDayRange(nextWeek.rangeSelectDay, nextWeek.startOfWeek);
        return {
                weekRange: Presse_Page.Guide.updateWeekRange(state.weekRange, nextWeek.weekNumber),
                currentWeek: {
                  displayArrows: nextWeek.displayArrows,
                  rangeSelectDay: dayRange,
                  weekNumber: nextWeek.weekNumber,
                  weekIndex: nextWeek.weekIndex,
                  status: nextWeek.status,
                  startOfWeek: nextWeek.startOfWeek
                }
              };
    case /* OnChangeDay */1 :
        var newDayRange = Presse_Page.Guide.updateStatusIntoDayRange(state.currentWeek.rangeSelectDay, action._0);
        var init = state.currentWeek;
        return {
                weekRange: state.weekRange,
                currentWeek: {
                  displayArrows: init.displayArrows,
                  rangeSelectDay: newDayRange,
                  weekNumber: init.weekNumber,
                  weekIndex: init.weekIndex,
                  status: init.status,
                  startOfWeek: init.startOfWeek
                }
              };
    case /* OnWeekNavigation */2 :
        if (action._0) {
          var previousWeekNumber = state.currentWeek.weekNumber - 1 | 0;
          var previousWeek = Presse_Page.Guide.getSelectWeekRange(state.weekRange, previousWeekNumber, state.currentWeek);
          var dayRange$1 = Presse_Page.Guide.updateStatusIntoDayRange(previousWeek.rangeSelectDay, selectedDate);
          return {
                  weekRange: Presse_Page.Guide.updateWeekRange(state.weekRange, previousWeek.weekNumber),
                  currentWeek: {
                    displayArrows: previousWeek.displayArrows,
                    rangeSelectDay: dayRange$1,
                    weekNumber: previousWeek.weekNumber,
                    weekIndex: previousWeek.weekIndex,
                    status: previousWeek.status,
                    startOfWeek: previousWeek.startOfWeek
                  }
                };
        }
        var nextWeekNumber = state.currentWeek.weekNumber + 1 | 0;
        var nextWeek$1 = Presse_Page.Guide.getSelectWeekRange(state.weekRange, nextWeekNumber, state.currentWeek);
        var dayRange$2 = Presse_Page.Guide.updateStatusIntoDayRange(nextWeek$1.rangeSelectDay, selectedDate);
        return {
                weekRange: Presse_Page.Guide.updateWeekRange(state.weekRange, nextWeek$1.weekNumber),
                currentWeek: {
                  displayArrows: nextWeek$1.displayArrows,
                  rangeSelectDay: dayRange$2,
                  weekNumber: nextWeek$1.weekNumber,
                  weekIndex: nextWeek$1.weekIndex,
                  status: nextWeek$1.status,
                  startOfWeek: nextWeek$1.startOfWeek
                }
              };
    
  }
}

function Layout_Guide_Slider_Presse(Props) {
  var initialDate = Props.initialDate;
  var getSelectedDate = Props.getSelectedDate;
  var selectedDate = Props.selectedDate;
  var downloadItems = Props.downloadItems;
  var downloadAllLabel = Props.downloadAllLabel;
  var weekPrefixLabel = Props.weekPrefixLabel;
  var weekItems = React.useMemo((function () {
          return Presse_Page.Guide.makeWeekRangeItems(initialDate, selectedDate);
        }), [
        selectedDate,
        initialDate
      ]);
  var intialState_currentWeek = Presse_Page.Guide.setInitialeState(selectedDate, weekItems);
  var intialState = {
    weekRange: weekItems,
    currentWeek: intialState_currentWeek
  };
  var match = React.useReducer((function (param, param$1) {
          return reducer(selectedDate, param, param$1);
        }), intialState);
  var dispatch = match[1];
  var state = match[0];
  var onWeekClick = function (index, startOfWeek) {
    Curry._1(dispatch, {
          TAG: /* OnChangeWeek */0,
          _0: index
        });
    Curry._1(getSelectedDate, startOfWeek);
  };
  var onClick = function (value) {
    Curry._1(dispatch, {
          TAG: /* OnChangeDay */1,
          _0: value
        });
    Curry._1(getSelectedDate, value);
  };
  var handleArrowClick = function (direction) {
    Curry._1(dispatch, {
          TAG: /* OnWeekNavigation */2,
          _0: direction
        });
  };
  return React.createElement(Atom_Column.make, {
              children: null
            }, React.createElement(Molecule_Select_Week_Presse.make, {
                  items: state.weekRange,
                  onClick: onWeekClick,
                  downloadItems: downloadItems,
                  downloadAllLabel: downloadAllLabel,
                  weekPrefixLabel: weekPrefixLabel
                }), React.createElement(Atom_Divider.make, {
                  style: Atom_Divider.presseGuide
                }), React.createElement(Molecule_Select_Days_Presse.make, {
                  daysRange: state.currentWeek.rangeSelectDay,
                  handleOnClick: onClick,
                  handleArrowClick: handleArrowClick,
                  displayArrows: state.currentWeek.displayArrows
                }));
}

var make = Layout_Guide_Slider_Presse;

export {
  reducer ,
  make ,
}
/* react Not a pure module */
